module.exports = "<svg width=\"94\" height=\"64\" viewBox=\"0 0 94 64\" xmlns=\"http://www.w3.org/2000/svg\">\n  <title>\n    “\n  </title>\n  <path d=\"M44 0l-6.89 64H0L16.199 0H44zm50 0l-7.025 64H50L66.241 0H94z\" fill=\"#FFF\" fill-rule=\"evenodd\"/>\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./assets/svg/quote-open.svg
// module id = 3739
// module chunks = 168707334958949